export const calculateProgress = async (
  durationMap,
  durationInSeconds,
  startTimestamp
) => {
  const sortedDurationKeys = Object.keys(durationMap).sort((a, b) => a - b);
  const sortedVideoIds = sortedDurationKeys.map((key) => durationMap[key]);

  const timeDifferenceInSeconds =
    (new Date().getTime() - startTimestamp) / 1000;

  const currentRoundProgress = timeDifferenceInSeconds % durationInSeconds;

  for (let i = 0; i < sortedDurationKeys.length - 1; i++) {
    if (
      currentRoundProgress > sortedDurationKeys[i] &&
      currentRoundProgress < sortedDurationKeys[i + 1]
    ) {
      return {
        videoId: durationMap[sortedDurationKeys[i]],
        progress: currentRoundProgress - sortedDurationKeys[i],
        remaining: durationInSeconds - currentRoundProgress,
        playingIndex: i,
        queue: sortedVideoIds,
      };
    }
  }

  return {
    videoId: durationMap[sortedDurationKeys[sortedDurationKeys.length - 1]],
    progress:
      currentRoundProgress - sortedDurationKeys[sortedDurationKeys.length - 1],
    remaining: durationInSeconds - currentRoundProgress,
    playingIndex: sortedDurationKeys.length - 1,
    queue: sortedVideoIds,
  };
};
